import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import Breadcrumb from "../../../layout/breadcrumb";
import React, {Fragment, useEffect, useState} from "react";
import {Card, CardBody, Col, Container, Form, FormGroup, Label, Row} from "reactstrap";
import {useFieldArray, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {schema} from "../../manage-order/dispatch-order";
import Select from "react-select";
import {getSelectedSettingData, storeSettingsData} from "../../report/backInStockReport/store/backInReportSlice";


const defaultValues = {
    name:'',
    is_percentage: '',
    value: '',
}

const GeneralSetting = () =>{
    const {slug} = useParams();
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [dataList, setDataList] = useState([]);

    const {handleSubmit, formState, reset, register, setValue, getValues, trigger, control} = useForm({});




    const {fields, append, prepend, remove, swap, move, insert} = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "settingList", // unique name for your Field Array
        // keyName: "id", default to "id", you can change the key name
    });



    useEffect(()=>{
        dispatch(getSelectedSettingData()).then(res=>{
           setValue('settingList', res.payload);
            setDataList(res.payload);

        })
    }, [dispatch]);


    const boolOpts = [
        { value: 1, label: 'On' },
        { value: 0, label: 'Off' },
    ];


    // console.log(getValues(''))


    const {errors} = formState;

    const onSubmitForm = (data) => {
        console.log(data)
        const finalData = {
            data:data.settingList
        }

        dispatch(storeSettingsData(finalData)).then(res=>{
            console.log(res)
        })

    }

    const dataMenu = [
        {
            type: 0,
            text: "Settings",
        }
    ];

    return (
        <Fragment>
            <Breadcrumb title="Settings" data={dataMenu}/>
            <Container fluid={true} className="product-wrapper">
                {/*<div className="product-grid">*/}
                {/*    <div className="feature-products">*/}
                        <Col className="mt-4" sm="12">
                            <Card>
                                <CardBody>
                                    <Form onSubmit={handleSubmit(onSubmitForm)}>
                                        <Row className="pb-2 mb-1 align-items-center"
                                             style={{ borderBottom: '2px solid #e8e8e8' }}>
                                            <Col md={6}><span style={{ fontWeight: 600, color: '#898989' }}>Setting</span></Col>
                                            <Col md={6}><span style={{ fontWeight: 600, color: '#898989' }}>Value</span></Col>
                                        </Row>
                                        {fields && fields.map((field, index) => {
                                        // Render the value control from the setting's `type`.
                                        const type = field.type || "string";
                                        let control;
                                        if (type === "boolean") {
                                            const on = field.value === 1 || field.value === "1" || field.value === true
                                                || String(field.value).toLowerCase() === "true";
                                            control = (
                                                <Select
                                                    getOptionLabel={(o) => o.label}
                                                    getOptionValue={(o) => o.value}
                                                    {...register(`settingList.${index}.value`)}
                                                    defaultValue={on ? {label: 'On', value: 1} : {label: 'Off', value: 0}}
                                                    onChange={(e) => {
                                                        setValue(`settingList.${index}.value`, e.value);
                                                        trigger(`settingList.${index}.value`);
                                                    }}
                                                    options={boolOpts}
                                                />
                                            );
                                        } else if (type === "select") {
                                            const opts = (field.options || []).map((o) =>
                                                (typeof o === "object" ? o : {label: String(o), value: o}));
                                            control = (
                                                <Select
                                                    getOptionLabel={(o) => o.label}
                                                    getOptionValue={(o) => o.value}
                                                    {...register(`settingList.${index}.value`)}
                                                    defaultValue={opts.find((o) => String(o.value) === String(field.value))}
                                                    onChange={(e) => {
                                                        setValue(`settingList.${index}.value`, e.value);
                                                        trigger(`settingList.${index}.value`);
                                                    }}
                                                    options={opts}
                                                />
                                            );
                                        } else {
                                            control = (
                                                <input
                                                    defaultValue={field.value}
                                                    type={(type === "decimal" || type === "integer") ? "number" : "text"}
                                                    step={type === "decimal" ? "any" : undefined}
                                                    disabled={field.is_editable === false}
                                                    {...register(`settingList.${index}.value`)}
                                                    className="form-control"
                                                    style={{ border: '1px solid gray' }}
                                                />
                                            );
                                        }
                                        return (
                                        <Row key={field.index} className="align-items-center py-3"
                                             style={{ borderBottom: '1px solid #efefef' }}>
                                            <Col md={6}>
                                                <div style={{ fontWeight: 600, color: '#2c323f' }}>{field.label}</div>
                                                {field.description
                                                    ? <small className="d-block text-muted mt-1">{field.description}</small>
                                                    : null}
                                            </Col>
                                            <Col md={6}>
                                                {control}
                                            </Col>
                                        </Row>
                                            );
                                        })}
                                        <Row>
                                            <Col md={10}></Col>
                                            <Col md={2} style={{marginTop: 36}}>
                                                <button
                                                    style={{ border: '1px solid black' }}
                                                    onClick={() => {
                                                        // setActionBtn(1)
                                                    }}
                                                    className="btn btn-success btn-block"
                                                >
                                                    Save
                                                </button>
                                            </Col>
                                        </Row>

                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                {/*    </div>*/}
                {/*</div>*/}
            </Container>
        </Fragment>
    );
}

export default GeneralSetting;